import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  Paper,
  styled,
  TextField,
  Tooltip,
  Typography,
  Avatar
} from "@mui/material";
// import List from '@mui/joy/List';
// import ListItem from '@mui/joy/ListItem';
// import ListItemDecorator from '@mui/joy/ListItemDecorator';
// import Radio from '@mui/joy/Radio';
// import RadioGroup from '@mui/joy/RadioGroup';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  CREATE_BOOKING,
  CREATE_CUSTOMER_SIDE_BOOKING,
  FIND_US_LIST,
  GET_BOOKING_DATA,
  GET_COMPANY_HOURS,
  GET_CUSTOMER_WITH_ID,
  GET_FREQUENCY_LIST,
  USER_CARD_DETAILS,
  USER_SIDE_GET_CARDS,
  VALIDATE_CODE,
} from "../../api";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../../axios";
import PhoneIcon from "@mui/icons-material/Phone";
import Logo from "../../../assets/logo.png";
import CoverImage from "../../../assets/coverImage.png";
import AddIcon from "@mui/icons-material/Add";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import * as Yup from "yup";
import { getItemEligibilityLabel, isItemEligible } from "../../utils/bookingItemEligibility";
import { useFormik, Form, FormikProvider, ErrorMessage, Field } from "formik";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { LoadingButton } from "@mui/lab";
import * as _ from "lodash";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import {
  CardElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import { getTenantStripePromise } from "../../utils/stripe";
import { baseImageUrl, apiPathUrl } from "../../utils/config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useAuth from "../../hooks/useAuth";
import { Span } from "../../components/Typography";
import { AccessTime } from "@mui/icons-material";
import {
  creditCardIcon,
  renderItemDataOrEmptyNull,
  stringReplace,
} from "../../utils/utils";
import { MuiTelInput } from "mui-tel-input";
import { ScrollToError } from "../../utils/scrollToError";
import BookingSelectionBreakdown from "../../components/BookingSelectionBreakdown";
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      border: "1px solid gray",
      color: "#303238",
      fontSize: "16px",
      fontFamily: "sans-serif",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#818082",
      },
    },
    invalid: {
      color: "#e5424d",
      ":focus": {
        color: "#303238",
      },
    },
  },
};

const PRIMARY_BLUE = "#3498db";
/** Deeper blue used across this flow (matches MUI / app accents) */
const PRIMARY_BLUE_DEEP = "#1976d2";
const PAGE_BG = "#f4f8fc";
const CARD_RADIUS = "12px";
/** Space above/below horizontal rules so headers don’t sit on the line */
const SECTION_DIVIDER_SX = {
  mt: "2.5rem",
  mb: "2rem",
};
const HERO_DIVIDER_SX = {
  mt: "1.25rem",
  mb: "2rem",
};

const getItemDiscountAmount = (item) => {
  const discountValue = Number(
    item?.discount_value ?? item?.discount_amount ?? item?.discount_percent
  ) || 0;
  if (item?.discount_type === "fixed") return discountValue;
  return (discountValue * (Number(item?.price) || 0)) / 100;
};

const getSelectedDateValue = (value) =>
  value && moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : "";

const StepHeader = ({ step, title, subtitle, sx }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 2,
      mb: 2,
      ...sx,
    }}
  >
    <Box
      sx={{
        width: 36,
        height: 36,
        minWidth: 36,
        borderRadius: "50%",
        bgcolor: PRIMARY_BLUE,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: "1rem",
      }}
    >
      {step}
    </Box>
    <Box sx={{ textAlign: "left", flex: 1 }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "#1e3a5f", mb: 0.5, lineHeight: 1.3 }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" sx={{ color: "#6b7b90" }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  </Box>
);

function ExtraBookingIcon({ data, selected }) {
  const [imgError, setImgError] = useState(false);
  const showImg = Boolean(data?.image_12) && !imgError;
  return (
    <Box
      sx={{
        width: 72,
        height: 72,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1,
      }}
    >
      {showImg ? (
        <Box
          component="img"
          src={`${baseImageUrl}${data?.image_12}`}
          alt={data?.title || ""}
          onError={() => setImgError(true)}
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            objectFit: "cover",
            border: "2px solid #fff",
            boxShadow: selected
              ? `0 0 0 2px ${PRIMARY_BLUE}`
              : "0 1px 4px rgba(0,0,0,0.08)",
          }}
        />
      ) : (
        <Avatar
          sx={{
            width: 72,
            height: 72,
            bgcolor: PRIMARY_BLUE,
            fontSize: "1.25rem",
            fontWeight: 600,
            boxShadow: selected
              ? `0 0 0 2px ${PRIMARY_BLUE}`
              : "0 1px 4px rgba(0,0,0,0.08)",
          }}
        >
          {(data?.title || "?").substring(0, 2).toUpperCase()}
        </Avatar>
      )}
    </Box>
  );
}

const MainBox = styled(Box)(({ theme }) => ({
  backgroundColor: PAGE_BG,
  minHeight: "100vh",
  "& .topHeader": {
    position: "fixed",
    width: "100%",
    backgroundColor: "#fff",
    zIndex: "999",
    boxShadow:
      "rgba(50, 50, 93, 0.15) 0px 4px 12px -2px, rgba(0, 0, 0, 0.08) 0px 2px 6px -2px",
    "& .logoContainer": {
      padding: "8px 0",
      "& img": {
        width: "180px",
        maxHeight: "48px",
        objectFit: "contain",
      },
    },
    "& .signInBtn": {
      color: "#3498db",
      fontSize: "1rem",
      fontWeight: "600",
    },
    "& .bodyTxt": {
      color: "#3498db",
      paddingRight: "0.3rem",
    },
  },
  "& .contentMain": {
    paddingTop: "7rem",
    paddingBottom: "3rem",
    "& .bookingTitle": {
      textAlign: "center",
      fontWeight: "bold",
      paddingBottom: "1rem",
      paddingTop: "1rem",
    },
    "& .coverImage": {
      width: "100%",
    },
    "& .tell-us": {},
    "& .subHeadings": {
      fontWeight: "bold",
      fontSize: "1.4rem",
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
  },
}));
const DateWrapper = styled("div")(() => ({
  "& .react-datepicker": {
    width: "100%",
    border: "1px solid #e1e8ef",
    borderRadius: CARD_RADIUS,
    overflow: "hidden",
    fontFamily: "inherit",
    "& .react-datepicker__header": {
      backgroundColor: PRIMARY_BLUE,
      borderBottom: "none",
      paddingTop: "12px",
    },
    "& .react-datepicker__current-month": {
      color: "#fff",
      fontWeight: 600,
      paddingBottom: "8px",
    },
    "& .react-datepicker__day-name": {
      color: "rgba(255,255,255,0.9)",
    },
    "& .react-datepicker__navigation": {
      top: "10px",
    },
    "& .react-datepicker__navigation-icon::before": {
      borderColor: "#fff",
    },
    "& .react-datepicker__day--selected, & .react-datepicker__day--keyboard-selected":
      {
        backgroundColor: PRIMARY_BLUE,
        borderRadius: "8px",
      },
    "& .react-datepicker__day:hover": {
      borderRadius: "8px",
    },
    "& .react-datepicker__month-container": {
      width: "100%",
      "& .react-datepicker__day-names": {
        display: "flex",
        justifyContent: "space-evenly",
        backgroundColor: PRIMARY_BLUE,
        paddingBottom: "8px",
      },
      "& .react-datepicker__week": {
        display: "flex",
        justifyContent: "space-evenly",
      },
    },
  },
  "& .error": {
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    textAlign: "left",
    marginTop: "4px",
    marginRight: "14px",
    marginBottom: 0,
    marginLeft: "14px",
    color: "#FF3D57",
  },
}));
const StyledItem = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minWidth: "fit-content",
  cursor: "pointer",
  "& a": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  },
  "& span": { marginRight: "10px", color: theme.palette.text.primary },
}));
const TimeWrapper = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "10px",
  "@media (max-width: 480px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  "& .timeItemStyle": {
    border: `1px solid ${PRIMARY_BLUE}`,
    borderRadius: "10px",
    cursor: "pointer",
    background: "rgba(52, 152, 219, 0.08)",
    padding: "10px 12px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& input": {
      marginTop: "0",
      cursor: "pointer",
    },
    '& input[type="radio"]': {
      webkitAppearance: "none",
      mozAppearance: "none",
      appearance: "none",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      border: "1px solid #a3a4a4",
      backgroundColor: "white",
      outline: "none",
      marginRight: "6px",
      transition: "border-color 0.2s ease-in-out",
    },
    '& input[type="radio"]:checked': {
      backgroundColor: "#3498db",
      borderColor: "#3498db",
    },
    '& input[type="radio"]:checked::before': {
      content: '""',
      display: "block",
      width: "5px",
      height: "5px",
      borderRadius: "50%",
      backgroundColor: "white",
      position: "relative",
      top: "51%",
      left: "51%",
      transform: "translate(-50%, -50%)",
    },
    "& label": {
      cursor: "pointer",
      whiteSpace: "nowrap",
      lineHeight: 1.2,
    },
  },
  "& .timeSelected": {
    background: "rgba(52, 152, 219, 0.22)",
    borderWidth: "2px",
    borderColor: PRIMARY_BLUE,
    boxShadow: `inset 0 0 0 1px ${PRIMARY_BLUE}`,
  },
  "& .error": {
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    textAlign: "left",
    marginTop: "4px",
    marginRight: "14px",
    marginBottom: 0,
    marginLeft: "14px",
    color: "#FF3D57",
  },
}));

function CustomerBooking() {
  const stripePromise = useMemo(() => getTenantStripePromise(), []);
  const token = localStorage.getItem("accessToken");
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const params = useParams();
  const bookingSlug = params?.slug;
  const userId = userDetails?.user_id;
  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState([]);
  const [userCardDetails, setUserCardDetails] = useState([]);
  const [streetValue, setStreetValue] = useState(null);
  const [validDateTimeList, setValidDateTimeList] = useState({});
  const addressGeocodeRequest = useRef(0);
  const packageFieldRefs = useRef([]);
  const [missingPackageIndexes, setMissingPackageIndexes] = useState([]);
  const [findUsList, setFindUsList] = useState([]);
  const [frequencyArray, setFrequencyArray] = useState([]);
  const [promoDiscount, setPromoDiscount] = useState(null);
  const [giftCardCode, setGiftCardCode] = useState("");
  const [giftCardDiscount, setGiftCardDiscount] = useState(null);
  const [giftCardCodeModal, setGiftCardCodeModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("stripe");
  const [customerDetail, setCustomerDetail] = useState(null);
  const [whyCleanyExpanded, setWhyCleanyExpanded] = useState("panel2");
  const streetTerms = streetValue?.value?.terms;
  const createBookingEndpoint =
    token || userDetails?.role === "Customer"
      ? CREATE_CUSTOMER_SIDE_BOOKING
      : CREATE_BOOKING;
  const getMissingRequiredPackageIndexes = () =>
    (bookingData?.packages || [])
      .slice()
      .sort((a, b) => a.order - b.order)
      .reduce((missingIndexes, packageData, index) => {
        if (packageData?.item?.length > 0 && !selectedItems[index]?.id) {
          missingIndexes.push(index);
        }
        return missingIndexes;
      }, []);
  const validateRequiredPackages = () => {
    const missingIndexes = getMissingRequiredPackageIndexes();
    setMissingPackageIndexes(missingIndexes);
    if (missingIndexes.length) {
      const firstMissingField = packageFieldRefs.current[missingIndexes[0]];
      firstMissingField?.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => {
        firstMissingField
          ?.querySelector("input, [role='combobox']")
          ?.focus();
      }, 350);
      return false;
    }
    return true;
  };
  const getFrequencyList = async () => {
    const res = await axios.get(`${apiPathUrl}${GET_FREQUENCY_LIST}/`);
    setFrequencyArray(res?.data?.data || []);
  };
  const getFindUsList = async () => {
    await axios
      .get(`${apiPathUrl}${FIND_US_LIST}`)
      .then((res) => {
        setFindUsList(res?.data?.data);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    getFrequencyList();
    getFindUsList();
  }, []);
  const { logout } = useAuth();

  const handleWhyCleanyAccordion =
    (panel) => (event, isExpanded) => {
      setWhyCleanyExpanded(isExpanded ? panel : false);
    };

  const schema = Yup.object().shape({
    start_time: Yup.string().required("Start time is required!"),
    frequency: Yup.string().required("Frequency is required!"),
    // .test('Time should be between 9 to 5', (value, { createError }) => {
    //   if (+value?.split(':')[0] < 9 || +value?.split(':')[0] > 17) {
    //     return createError({ message: 'Time should be between 9 to 5' });
    //   }
    //   if (+value?.split(':')[0] === 17 && +value?.split(':')[1] > 0) {
    //     return createError({ message: 'Time should be between 9 to 5' });
    //   }
    //   return true;
    // }),
    start_date: Yup.string().required("Start date is required!"),
    first_name: Yup.string()
      .trim()
      .matches(/^[A-Za-z][A-Za-z\s'-]*$/, "Enter a valid first name")
      .required("First name is required!"),
    last_name: Yup.string()
      .trim()
      .matches(/^[A-Za-z][A-Za-z\s'-]*$/, "Enter a valid last name")
      .required("Last name is required!"),
    email: Yup.string()
      .email("Enter proper email address!")
      .required("Email is required!"),
    phone: Yup.string()
      .required("Phone no is required!")
      .test("valid-phone", "Enter a valid phone number!", (value) => {
        const digits = String(value || "").replace(/\D/g, "");
        return digits.length >= 10 && digits.length <= 15;
      }),
    street_address: Yup.string().required("Street address is required!"),
    city: Yup.string().required("City is required!"),
    state: Yup.string().required("State is required!"),
    zip_code: Yup.string()
      .trim()
      .matches(/^\d{5}(?:-\d{4})?$/, "Enter a valid ZIP code!")
      .required("Zip Code is required!"),
    // additional_info: Yup.string().required('Additional information is required!'),
    // customer_notes: Yup.string().required('Customer notes are required!'),
    how_to_enter_on_premise: Yup.string().required("This field is required!"),
    do_you_pets: Yup.string().required("Select an option!"),
    package_selection: Yup.string().required("Select minimum 1 package!"),
  });

  const formik = useFormik({
    initialValues: {
      start_time: "",
      start_date: "",
      first_name: "",
      last_name: "",
      email: userDetails?.email || "",
      phone: "",
      street_address: "",
      apt_suite: "",
      city: "",
      frequency: "",
      state: "",
      zip_code: "",
      hear_about_us: "",
      promo_code: localStorage.getItem("promoCodeForBooking") || "",
      additional_info: "",
      how_to_enter_on_premise: "",
      card_token: "",
      package_selection: "",
      // customer_notes: '',
      latitude: "",
      do_parking_spot: false,
      cardHolderName: "",
      longitude: "",
      do_you_pets: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (!validateRequiredPackages()) return;

      const hasValidCoordinates =
        values?.latitude !== null &&
        values?.latitude !== "" &&
        values?.longitude !== null &&
        values?.longitude !== "" &&
        Number.isFinite(Number(values?.latitude)) &&
        Number.isFinite(Number(values?.longitude));
      if (!hasValidCoordinates) {
        toast.error("Please select a valid service address before booking.");
        return;
      }

      if (!availableTimes.some((slot) => slot.value === values.start_time)) {
        setFieldTouched("start_time", true, false);
        setFieldError("start_time", "Select an available time for the chosen date!");
        toast.error("Please select an available time for the chosen date.");
        return;
      }

      setLoading(true);
      try {
        if (stripe && elements && selectedMethod === "stripe") {
          const cardElement = elements.getElement(CardElement);
          const result = await stripe.createToken(cardElement, {
            name: values.cardHolderName,
          });
          if (result.error) {
            setLoading(false);
            toast.error(result.error.message);
            setFieldValue("card_token", "");
          } else {
            toast.success("Card successfully applied!");
            setFieldValue("card_token", result.token.id);
            const itemMapData = _.compact(selectedItems).map((item) => {
              return { item_id: item?.id, package: item?.packageData };
            });
            const objToSend = {
              contact_info: {
                first_name: values?.first_name,
                last_name: values?.last_name,
                email: values?.email,
                phone: values?.phone,
                how_to_enter_on_premise: values?.how_to_enter_on_premise,
                do_parking_spot: !!values?.do_parking_spot,
                do_you_pets: values?.do_you_pets,
                how_do_you_hear_about_us: values?.hear_about_us,
              },
              service_location: {
                street_address: values?.street_address,
                ...(values?.apt_suite?.trim()
                  ? { apt_suite: values.apt_suite.trim() }
                  : {}),
                city: values?.city,
                state: values?.state,
                zip_code: values?.zip_code,
                let_long: "",
              },
              extras: _.compact(selectedExtras),
              items: itemMapData,
              booking_type: values?.frequency,
              service_id: bookingData?.id,
              start_time: values?.start_time || "",
              start_date: getSelectedDateValue(values?.start_date),
              additional_info: values?.additional_info,
              // customer_notes: values?.customer_notes,
              latitude: values?.latitude,
              longitude: values?.longitude,
              source:
                token || userDetails?.role === "Customer"
                  ? "Web-App"
                  : "Web-Link",
              card_token:
                selectedMethod === "zelle"
                  ? "ZILLE"
                  : values?.card_token || result.token.id,
            };
            if (giftCardDiscount && giftCardCode) {
              objToSend["gift_card"] = giftCardCode;
            }
            if (promoDiscount && values?.promo_code) {
              objToSend["promo_code"] = values?.promo_code;
            }
            localStorage.setItem(
              "allBookingdata",
              JSON.stringify({
                ...objToSend,
                company: bookingData?.company,
              })
            );

            toast.promise(
              axios.post(
                `${apiPathUrl}${createBookingEndpoint}/${bookingData?.id}`,
                objToSend,
                {
                  headers: { "Content-Type": "application/json" },
                }
              ),
              {
                loading: () => {
                  return `Creating Booking!`;
                },
                success: (res) => {
                  localStorage.removeItem("promoCodeForBooking");
                  setLoading(false);
                  const stateToPass = {
                    bookingData: {
                      ...objToSend,
                      booking_id:
                        res?.data?.data?.booking_id || res?.data?.data?.booking,
                    },
                    checkoutData: {
                      selectedExtras,
                      values,
                      availableTimes,
                      selectedItems,
                      estimatedTax,
                      promoDiscount,
                      giftCardDiscount,
                      todaysTotal,
                      codesDiscount,
                    },
                  };
                  let confirmBookingRoute =
                    selectedMethod === "zelle"
                      ? "/zelleCheckout"
                      : "/confirmBooking";
                  // setTimeout(() => {
                  //   navigate(
                  //     let confirmBookingRoute = token === null ? "/session/signup" : "/confirmBooking"
                  //   );
                  // }, 500);
                  setTimeout(() => {
                    navigate(confirmBookingRoute, { state: stateToPass });
                  }, 500);
                  return res?.data?.message;
                },
                error: (err) => {
                  setLoading(false);
                  return err?.response?.data?.message || err?.message;
                },
              }
            );
          }
        } else {
          const itemMapData = _.compact(selectedItems).map((item) => {
            return { item_id: item?.id, package: item?.packageData };
          });
          const objToSend = {
            contact_info: {
              first_name: values?.first_name,
              last_name: values?.last_name,
              email: values?.email,
              phone: values?.phone,
              how_to_enter_on_premise: values?.how_to_enter_on_premise,
              do_parking_spot: !!values?.do_parking_spot,
              do_you_pets: values?.do_you_pets,
              how_do_you_hear_about_us: values?.hear_about_us,
            },
            service_location: {
              street_address: values?.street_address,
              ...(values?.apt_suite?.trim()
                ? { apt_suite: values.apt_suite.trim() }
                : {}),
              city: values?.city,
              state: values?.state,
              zip_code: values?.zip_code,
              let_long: "",
            },
            extras: _.compact(selectedExtras),
            items: itemMapData,
            booking_type: values?.frequency,
            service_id: bookingData?.id,
            start_time: values?.start_time || "",
            start_date: getSelectedDateValue(values?.start_date),
            additional_info: values?.additional_info,
            // customer_notes: values?.customer_notes,
            latitude: values?.latitude,
            longitude: values?.longitude,
            source:
              token || userDetails?.role === "Customer" ? "Web-App" : "Web-Link",
            card_token:
              selectedMethod === "zelle" ? "ZILLE" : values?.card_token,
          };
          if (giftCardDiscount && giftCardCode) {
            objToSend["gift_card"] = giftCardCode;
          }
          if (promoDiscount && values?.promo_code) {
            objToSend["promo_code"] = values?.promo_code;
          }
          localStorage.setItem(
            "allBookingdata",
            JSON.stringify({
              ...objToSend,
              company: bookingData?.company,
            })
          );
          toast.promise(
            axios.post(
              `${apiPathUrl}${createBookingEndpoint}/${bookingData?.id}`,
              objToSend,
              {
                headers: { "Content-Type": "application/json" },
              }
            ),
            {
              loading: () => {
                return `Creating Booking!`;
              },
              success: (res) => {
                localStorage.removeItem("promoCodeForBooking");
                setLoading(false);
                const stateToPass = {
                  bookingData: {
                    ...objToSend,
                    booking_id:
                      res?.data?.data?.booking_id || res?.data?.data?.booking,
                  },
                  checkoutData: {
                    selectedExtras,
                    values,
                    availableTimes,
                    selectedItems,
                    estimatedTax,
                    promoDiscount,
                    giftCardDiscount,
                    todaysTotal,
                    codesDiscount,
                  },
                };
                let confirmBookingRoute =
                  selectedMethod === "zelle"
                    ? "/zelleCheckout"
                    : "/confirmBooking";
                // setTimeout(() => {
                //   navigate(
                //     let confirmBookingRoute = token === null ? "/session/signup" : "/confirmBooking"
                //   );
                // }, 500);
                setTimeout(() => {
                  navigate(confirmBookingRoute, { state: stateToPass });
                }, 500);
                return res?.data?.message;
              },
              error: (err) => {
                setLoading(false);
                return err?.response?.data?.message || err?.message;
              },
            }
          );
        }
      } catch (error) {
        console.log("in error", error);
        setLoading(false);
      }
    },
  });
  const setFieldValue = formik.setFieldValue;

  useEffect(() => {
    if (streetTerms?.length) {
      const state = streetTerms[streetTerms.length - 2];
      const city = streetTerms[streetTerms.length - 3];
      setFieldValue("state", state?.value || "");
      setFieldValue("city", city?.value || "");
    }
  }, [setFieldValue, streetTerms]);

  useEffect(() => {
    const callApi = async () => {
      await axios
        .get(`${apiPathUrl}${GET_BOOKING_DATA}/${bookingSlug}`)
        .then((res) => {
          setBookingData(res?.data?.data);
        })
        .catch((err) => console.log("err", GET_BOOKING_DATA, err));

      await axios
        .get(`${apiPathUrl}${USER_SIDE_GET_CARDS}`)
        .then((res) => {
          setUserCardDetails(res?.data?.data?.data);
          if (res?.data?.data?.data?.length) {
            setSelectedCard(res?.data?.data?.data[0]?.id);
          }
        })
        .catch((err) => console.log("err", USER_CARD_DETAILS, err));
    };
    callApi();
  }, [bookingSlug]);
  useEffect(() => {
    const getCustomerDetail = async () => {
      await axios
        .get(`${apiPathUrl}${GET_CUSTOMER_WITH_ID}?user_id=${userId}`)
        .then((res) => {
          const dupObj = { ...res?.data?.data };
          dupObj.address = stringReplace(
            stringReplace(res?.data?.data?.user_profile?.address, `('`, ""),
            `',)`,
            ""
          );
          dupObj.road = stringReplace(
            stringReplace(res?.data?.data?.user_profile?.address, `('`, ""),
            `',)`,
            ""
          );
          dupObj.city = res?.data?.data?.user_profile?.city;
          dupObj.state = res?.data?.data?.user_profile?.state;
          dupObj.zip_code = stringReplace(
            stringReplace(res?.data?.data?.user_profile?.zip_code, `('`, ""),
            `',)`,
            ""
          );
          dupObj.first_name = res?.data?.data?.user_profile?.first_name;
          dupObj.last_name = res?.data?.data?.user_profile?.last_name;
          dupObj.phone_no = stringReplace(
            stringReplace(
              res?.data?.data?.user_profile?.phone_number,
              `('`,
              ""
            ),
            `',)`,
            ""
          );
          setCustomerDetail(dupObj);
          setFieldValue("email", dupObj?.email);
          setFieldValue("phone", dupObj?.phone_no);
        })
        .catch((err) => console.error(err));
    };
    if (userId) {
      getCustomerDetail();
    }
  }, [setFieldValue, userId]);
  useEffect(() => {
    if (bookingData?.company) {
      axios
        .get(`${apiPathUrl}${GET_COMPANY_HOURS}/${bookingData?.company}/`)
        .then((res) => {
          setValidDateTimeList(res?.data);
        })
        .catch((err) => console.log("err", GET_COMPANY_HOURS, err));
    }
  }, [bookingData?.company]);

  const handleSelectPackageData = (value, index, packageData) => {
    const isFirstBooking = bookingData?.is_first_booking ?? customerDetail?.is_first_booking;
    if (value && !isItemEligible(value, isFirstBooking)) return;
    const dupArr = [...selectedItems];
    dupArr[index] = value;

    if (value !== null) {
      dupArr[index].packageData = packageData?.id;
      setFieldValue("package_selection", value.title);
    } else if (!dupArr.some((iData) => iData?.id)) {
      setFieldValue("package_selection", "");
    }
    setSelectedItems(dupArr);
  };
  const handleExtrasClick = (data, index) => {
    const dupArr = [...selectedExtras];
    if (selectedExtras[index]?.quantity) {
      dupArr[index] = undefined;
      setSelectedExtras(dupArr);
    } else {
      dupArr[index] = {
        extra_id: data.id,
        quantity: 1,
        price: data?.price,
        time_hrs: data?.time_hrs,
      };
      setSelectedExtras(dupArr);
    }
  };
  const handleDecrement = (index) => {
    const dupArr = [...selectedExtras];
    if (dupArr[index].quantity > 1) {
      dupArr[index].quantity = dupArr[index].quantity - 1;
      setSelectedExtras(dupArr);
    }
  };
  const handleIncrement = (index) => {
    const dupArr = [...selectedExtras];
    dupArr[index].quantity = dupArr[index].quantity + 1;
    setSelectedExtras(dupArr);
  };
  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldError,
    setFieldTouched,
    values,
  } = formik;
  const handleBookingFormSubmit = (event) => {
    event.preventDefault();
    if (validateRequiredPackages()) handleSubmit(event);
  };
  const handleValidateGiftCard = () => {
    const data = {
      code: giftCardCode,
      service: bookingData?.id,
    };
    toast.promise(
      axios.post(`${apiPathUrl}${VALIDATE_CODE}`, data, {
        headers: { "Content-Type": "application/json" },
      }),
      {
        loading: () => {
          return `Validating Gift Card Code!`;
        },
        success: (res) => {
          setGiftCardDiscount(res?.data?.data?.amount);
          setGiftCardCodeModal(false);
          return res?.data?.message;
        },
        error: (err) => {
          setGiftCardCodeModal(false);
          return err?.response?.data?.message;
        },
      }
    );
  };
  const handleValidatePromo = () => {
    const data = {
      code: values.promo_code,
      service: bookingData?.id,
    };
    toast.promise(
      axios.post(`${apiPathUrl}${VALIDATE_CODE}`, data, {
        headers: { "Content-Type": "application/json" },
      }),
      {
        loading: () => {
          return `Validating Promo Code!`;
        },
        success: (res) => {
          setPromoDiscount(res?.data?.data?.amount);
          return res?.data?.message;
        },
        error: (err) => {
          return err?.response?.data?.message;
        },
      }
    );
  };
  useEffect(() => {
    if (!streetValue?.label) return;

    const requestId = ++addressGeocodeRequest.current;
    setFieldValue("street_address", streetValue.label);
    setFieldValue("latitude", "");
    setFieldValue("longitude", "");
    geocodeByAddress(streetValue.label)
      .then(async (results) => {
        const result = results[0];
        const coordinates = await getLatLng(result);
        return { result, coordinates };
      })
      .then(({ result, coordinates: { lat, lng } }) => {
        if (addressGeocodeRequest.current !== requestId) return;
        const components = result?.address_components || [];
        const getAddressComponent = (types, useShortName = false) => {
          const component = components.find((item) =>
            types.some((type) => item.types?.includes(type))
          );
          return component
            ? component[useShortName ? "short_name" : "long_name"]
            : "";
        };

        const city = getAddressComponent([
          "locality",
          "postal_town",
          "sublocality",
        ]);
        const state = getAddressComponent(["administrative_area_level_1"]);
        const zipCode = getAddressComponent(["postal_code"]);

        setFieldValue("city", city);
        setFieldValue("state", state);
        setFieldValue("zip_code", zipCode);
        setFieldValue("latitude", lat);
        setFieldValue("longitude", lng);
      })
      .catch((error) => {
        if (addressGeocodeRequest.current !== requestId) return;
        setFieldValue("latitude", "");
        setFieldValue("longitude", "");
        console.error("Unable to resolve service address coordinates", error);
      });
  }, [setFieldValue, streetValue]);

  // const handleCardSubmit = async (stripe, elements) => {
  //   if (!stripe || !elements) {
  //     return;
  //   }
  //   if (cardHolderName.trim() === '') {
  //     setNameError('This field is required.');
  //     return;
  //   }
  //   const card = elements.getElement(CardElement);
  //   const result = await stripe.createToken(card, {
  //     name: cardHolderName,
  //   });
  //   if (result.error) {
  //     toast.error(result.error.message);
  //     setFieldValue('card_token', '');
  //   } else {
  //     toast.success('Card successfully applied!');
  //     setFieldValue('card_token', result.token.id);
  //     setFieldValue('stripe_token', result.token.id);
  //   }
  // };

  const validDates = validDateTimeList
    ? Object.keys(validDateTimeList)
        .map((dateStr) => moment(dateStr, "YYYY-MM-DD", true))
        .filter((date) => date.isValid())
        .map((date) => date.toDate())
    : [];
  const filterDates = (date) => {
    return validDates.some(
      (validDate) => validDate.toDateString() === date.toDateString()
    );
  };
  // Function to convert 12-hour format to 24-hour format using moment.js
  const convertTo24HourFormat = (time) => {
    const timeMoment = moment(time, "hh:mm A");
    return timeMoment.format("HH:mm");
  };
  const availableTimes = useMemo(() => {
    if (values.start_date) {
      const timesList =
        validDateTimeList[
          `${moment(values.start_date)?.format("YYYY-MM-DD")}`
        ] || [];

      return timesList.map((z) => {
        return {
          label: z,
          value: convertTo24HourFormat(z),
        };
      });
    } else {
      return [];
    }
  }, [values.start_date, validDateTimeList]);

  const selectedBookingItems = _.compact(selectedItems);
  const selectedBookingExtras = _.compact(selectedExtras);
  const itemSubtotal = selectedBookingItems.reduce(
    (total, item) => total + (Number(item?.price) || 0),
    0
  );
  const itemDiscountTotal = selectedBookingItems.reduce(
    (total, item) => total + getItemDiscountAmount(item),
    0
  );
  const extrasTotal = selectedBookingExtras.reduce(
    (total, item) => total + (Number(item?.price) || 0) * (Number(item?.quantity) || 0),
    0
  );
  const totalValue = Math.max(0, itemSubtotal - itemDiscountTotal + extrasTotal);
  const estimatedTax = ((Number(bookingData?.tax?.[0]?.tax_rate) || 0) / 100) * totalValue;
  const todaysTotal = estimatedTax + totalValue;
  const codesDiscount = (promoDiscount || 0) + (giftCardDiscount || 0);
  const finalTotal = Math.max(0, todaysTotal - codesDiscount);
  const totalHours =
    selectedBookingItems.reduce(
      (total, item) => total + (Number(item?.time_hrs) || 0),
      0
    ) +
    selectedBookingExtras.reduce(
      (total, item) =>
        total + (Number(item?.time_hrs) || 0) * (Number(item?.quantity) || 0),
      0
    );
  return (
    <MainBox>
      <Box className="topHeader">
        <Container maxWidth="lg">
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Box className="logoContainer">
              <a
                href={token ? "/dashboard/default" : "https://www.bookcleany.com"}
                rel="noreferrer"
              >
                <img
                  src={Logo}
                  alt="Cleany"
                  className="logoImg"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </Box>
            <Box display={"flex"} alignItems="center">
              <Box display={"flex"} alignItems="center">
                <PhoneIcon className="bodyTxt" />
                <Typography
                  variant="body1"
                  className="bodyTxt"
                  style={{ cursor: "pointer" }}
                >
                  <a href="tel:+12128516134">+1(212)851-6134</a>
                </Typography>
              </Box>
              {token && userDetails && (
                <Box
                  display={"flex"}
                  alignItems="center"
                  sx={{ marginLeft: "1rem" }}
                >
                  <StyledItem
                    onClick={() => {
                      logout();
                      navigate(`/session/signin`);
                    }}
                  >
                    <Icon> power_settings_new </Icon>
                    <Span> Logout </Span>
                  </StyledItem>
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg" className="contentMain">
        <Grid container columnSpacing={{ xs: 0, md: 4 }} rowSpacing={3}>
          <Grid item xs={12} lg={8}>
            <Box
              sx={{
                background: "white",
                p: { xs: 2, sm: 3 },
                width: "100%",
                border: "1px solid #e1e8ef",
                borderRadius: CARD_RADIUS,
                boxShadow: "0 4px 24px rgba(15, 41, 77, 0.06)",
                textAlign: "center",
                "& a": {
                  "&:hover": {
                    textDecoration: "underline",
                  },
                },
                "& .error": {
                  fontWeight: 400,
                  fontSize: "0.75rem",
                  lineHeight: 1.66,
                  letterSpacing: "0.03333em",
                  textAlign: "left",
                  marginTop: "4px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px",
                  color: "#FF3D57",
                },
              }}
            >
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleBookingFormSubmit}>
                  <ScrollToError />
                  <Box sx={{ mb: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={Logo}
                        alt="Cleany"
                        sx={{ maxWidth: 200, height: "auto", maxHeight: 52 }}
                      />
                    </Box>
                    <Typography
                      variant="h4"
                      className="bookingTitle"
                      sx={{
                        textTransform: "capitalize",
                        fontSize: { xs: "1.35rem !important", sm: "1.75rem !important" },
                        fontWeight: 700,
                        color: "#1e3a5f",
                        pt: 0,
                        pb: 1,
                      }}
                    >
                      {bookingData?.name}
                    </Typography>
                    <Box
                      component="img"
                      src={CoverImage}
                      alt=""
                      className="coverImage"
                      sx={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        mt: 2,
                        mb: 2,
                        borderRadius: CARD_RADIUS,
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#6b7b90",
                        fontSize: "1rem",
                        display: "block",
                        mb: 0.5,
                      }}
                    >
                      Book in just 60 seconds —{" "}
                      <Box
                        component="a"
                        href="https://www.BookCleany.com"
                        sx={{ color: PRIMARY_BLUE, fontWeight: 600 }}
                      >
                        www.BookCleany.com
                      </Box>
                    </Typography>
                  </Box>
                  <Divider sx={HERO_DIVIDER_SX} />
                  <Box className="tell-us">
                    <StepHeader
                      step={1}
                      title="Tell us about the cleaning"
                      subtitle="Select property details"
                    />
                    <Grid container spacing={2}>
                      {bookingData?.packages?.length > 0 &&
                        bookingData?.packages
                          ?.slice()
                          ?.sort((a, b) => a.order - b.order)
                          ?.map((data, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              key={data?.id ?? `pkg-${index}`}
                            >
                              <TextField
                                ref={(node) => {
                                  packageFieldRefs.current[index] = node;
                                }}
                                fullWidth
                                type="text"
                                label={`${data?.title}*`}
                                select
                                size="small"
                                value={selectedItems[index]}
                                onChange={(e) => {
                                  handleSelectPackageData(
                                    e.target.value,
                                    index,
                                    data
                                  );
                                  setMissingPackageIndexes((current) =>
                                    current.filter((missingIndex) => missingIndex !== index)
                                  );
                                }}
                                name="package_selection"
                                error={Boolean(
                                  missingPackageIndexes.includes(index) ||
                                    (touched.package_selection &&
                                      errors.package_selection)
                                )}
                                helperText={
                                  missingPackageIndexes.includes(index)
                                    ? "Select an option for this required package!"
                                    : touched.package_selection &&
                                      errors.package_selection
                                }
                                sx={{
                                  textAlign: "left",
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "10px",
                                    backgroundColor: "#f8fafc",
                                  },
                                }}
                              >
                                {data?.item?.length > 0 ? data?.item?.map((item, itemIndex) => (
                                    <MenuItem
                                      value={item}
                                      key={itemIndex}
                                      disabled={!isItemEligible(
                                        item,
                                        bookingData?.is_first_booking ?? customerDetail?.is_first_booking,
                                      )}
                                    >
                                      {item?.title}
                                      {item?.eligibility_type && item.eligibility_type !== 'all'
                                        ? ` — ${getItemEligibilityLabel(item.eligibility_type)}`
                                        : ''}
                                    </MenuItem>
                                  )) : (
                                    <MenuItem disabled>No items yet</MenuItem>
                                  )}
                              </TextField>
                            </Grid>
                          ))}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          type="text"
                          label="Do you have pets?*"
                          select
                          size="small"
                          value={values.do_you_pets}
                          name="do_you_pets"
                          onChange={(e) =>
                            setFieldValue("do_you_pets", e.target.value)
                          }
                          error={Boolean(
                            touched.do_you_pets && errors.do_you_pets
                          )}
                          helperText={touched.do_you_pets && errors.do_you_pets}
                          sx={{
                            textAlign: "left",
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                              backgroundColor: "#f8fafc",
                            },
                          }}
                        >
                          <MenuItem value={"no pet"}>No Pet</MenuItem>
                          <MenuItem value={"Cat"}>Cat</MenuItem>
                          <MenuItem value={"Dog"}>Dog</MenuItem>
                          <MenuItem value={"Both"}>Both</MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                    <Divider sx={SECTION_DIVIDER_SX} />
                    <StepHeader
                      step={2}
                      title="Any Extras?"
                      subtitle="Price per cleaning — select all that apply"
                    />
                    <Grid
                      container
                      spacing={2}
                      sx={{ paddingTop: "0.5rem" }}
                    >
                      {bookingData?.extras?.length > 0 &&
                        bookingData?.extras
                          ?.slice()
                          ?.sort((a, b) => a.order - b.order)
                          ?.map((data, index) => {
                            const isSelected = Boolean(
                              selectedExtras[index]?.quantity
                            );
                            return (
                              <Grid
                                item
                                xs={6}
                                sm={4}
                                md={3}
                                key={data?.id ?? `extra-${index}`}
                              >
                                <Box sx={{ width: "100%", height: "100%" }}>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      minHeight: 168,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "column",
                                      color: "#1e3a5f",
                                      p: 1.5,
                                      backgroundColor: isSelected
                                        ? "rgba(52, 152, 219, 0.12)"
                                        : "#fff",
                                      border: isSelected
                                        ? `2px solid ${PRIMARY_BLUE}`
                                        : "1px solid #e1e8ef",
                                      borderRadius: "12px",
                                      cursor: "pointer",
                                      transition:
                                        "background 0.2s, border-color 0.2s",
                                      "&:hover": {
                                        borderColor: PRIMARY_BLUE,
                                        backgroundColor:
                                          "rgba(52, 152, 219, 0.08)",
                                      },
                                    }}
                                    onClick={() =>
                                      handleExtrasClick(data, index)
                                    }
                                  >
                                    <ExtraBookingIcon
                                      data={data}
                                      selected={isSelected}
                                    />
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        fontWeight: 600,
                                        textAlign: "center",
                                        lineHeight: 1.25,
                                        px: 0.5,
                                      }}
                                    >
                                      {data?.title}
                                      <Tooltip
                                        title={renderItemDataOrEmptyNull(
                                          data?.tool_tip
                                        )}
                                      >
                                        <HelpOutlineIcon
                                          sx={{
                                            fontSize: "16px",
                                            ml: 0.25,
                                            verticalAlign: "middle",
                                            color: "#6b7b90",
                                          }}
                                        />
                                      </Tooltip>
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        mt: 0.75,
                                        color: PRIMARY_BLUE,
                                        fontWeight: 600,
                                      }}
                                    >
                                      +$
                                      {data?.price != null
                                        ? Number(data.price).toFixed(2)
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                  {selectedExtras[index]?.quantity ? (
                                    <Box
                                      sx={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        py: 1,
                                        px: 1,
                                        mt: 0.5,
                                        borderRadius: "10px",
                                        backgroundColor:
                                          "rgba(52, 152, 219, 0.1)",
                                        border: `1px solid ${PRIMARY_BLUE}`,
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <RemoveCircleOutlineIcon
                                        sx={{ cursor: "pointer", color: PRIMARY_BLUE }}
                                        onClick={() => handleDecrement(index)}
                                      />
                                      <Box
                                        sx={{
                                          mx: 1,
                                          minWidth: "2.5rem",
                                          textAlign: "center",
                                          background: "white",
                                          fontSize: "1rem",
                                          fontWeight: 600,
                                          py: 0.5,
                                          border: "1px solid #e1e8ef",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        {selectedExtras[index]?.quantity}
                                      </Box>
                                      <AddCircleOutlineIcon
                                        sx={{ cursor: "pointer", color: PRIMARY_BLUE }}
                                        onClick={() => handleIncrement(index)}
                                      />
                                    </Box>
                                  ) : null}
                                </Box>
                              </Grid>
                            );
                          })}
                    </Grid>

                    <Divider sx={SECTION_DIVIDER_SX} />
                    <StepHeader
                      step={3}
                      title="Choose your frequency"
                      subtitle="Adjust, reschedule or postpone anytime"
                    />

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch",
                        flexWrap: "wrap",
                        marginTop: "0.5rem",
                        gap: 2,
                      }}
                    >
                      <Field name="frequency">
                        {({ field }) =>
                          frequencyArray.map((data, index) => (
                            <Button
                              size="large"
                              {...field}
                              key={index}
                              variant="outlined"
                              onClick={() =>
                                setFieldValue("frequency", data.type)
                              }
                              sx={{
                                flex: "1 1 140px",
                                minWidth: 120,
                                py: 1.75,
                                px: 2,
                                borderRadius: "12px",
                                textTransform: "none",
                                borderColor:
                                  values?.frequency === data.type
                                    ? PRIMARY_BLUE
                                    : "#d8dee6",
                                backgroundColor:
                                  values?.frequency === data.type
                                    ? "rgba(52, 152, 219, 0.12)"
                                    : "#fff",
                                color:
                                  values?.frequency === data.type
                                    ? "#1e3a5f"
                                    : "#1e3a5f",
                                fontWeight: 600,
                                flexDirection: "column",
                                alignItems: "flex-start",
                                "&:hover": {
                                  borderColor: PRIMARY_BLUE,
                                  backgroundColor: "rgba(52, 152, 219, 0.08)",
                                },
                              }}
                            >
                              <Typography
                                component="span"
                                sx={{ fontWeight: 700, fontSize: "1rem" }}
                              >
                                {data?.title}
                              </Typography>
                              {data?.offers?.title ? (
                                <Typography
                                  component="span"
                                  variant="caption"
                                  sx={{
                                    display: "block",
                                    mt: 0.5,
                                    color: PRIMARY_BLUE,
                                    fontWeight: 600,
                                  }}
                                >
                                  {data?.offers?.title}
                                </Typography>
                              ) : (
                                <Typography
                                  component="span"
                                  variant="caption"
                                  sx={{
                                    display: "block",
                                    mt: 0.5,
                                    color: "#6b7b90",
                                    fontWeight: 500,
                                  }}
                                >
                                  Standard
                                </Typography>
                              )}
                            </Button>
                          ))
                        }
                      </Field>
                    </Box>
                    <ErrorMessage
                      name="frequency"
                      component="div"
                      className="error"
                    />
                    {values?.frequency !== "once" && (
                      <>
                        <Typography
                          fontSize={"14px"}
                          color={"#8a94a9"}
                          marginTop={"20px"}
                        >{`The Cleany Loyalty discount will be applied on the second cleaning service and onwards. You can always make updates or changes in your online portal or reach out to our customer representative who can assist.`}</Typography>
                        <Box
                          display="flex"
                          alignItems={"center"}
                          justifyContent="space-between"
                        >
                          <Typography variant="h6" className="subHeadings">
                            Get more savings
                          </Typography>
                          <Button
                            variant="text"
                            color="inherit"
                            startIcon={<SavedSearchIcon />}
                          >
                            How it works
                          </Button>
                        </Box>

                        <Typography variant="body1">
                          The Cleany Happiness Guarantee applies to all
                          bookings. When you commit to a longer term plan, you
                          will save more.
                        </Typography>
                      </>
                    )}

                    <Divider sx={SECTION_DIVIDER_SX} />

                    <StepHeader
                      step={4}
                      title="Select a Date & Time"
                      subtitle="We'll confirm within 24 hours"
                    />
                    <Grid container spacing={3}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: "#5a6b7d",
                            mb: 1,
                            textAlign: "left",
                          }}
                        >
                          Date<span style={{ color: "red" }}>*</span>
                        </Typography>
                        <DateWrapper>
                          <DatePicker
                            {...getFieldProps("start_date")}
                            selected={values.start_date}
                            onChange={(date) => {
                              setFieldValue("start_date", date);
                              setFieldValue("start_time", "");
                            }}
                            inline
                            filterDate={filterDates}
                            error={Boolean(
                              touched.start_date && errors.start_date
                            )}
                            helperText={touched.start_date && errors.start_date}
                          />
                          <ErrorMessage
                            name="start_date"
                            component="div"
                            className="error"
                          />
                        </DateWrapper>
                        {/* <TextField
                          size="small"
                          fullWidth
                          type="date"
                          inputProps={{ min: `${moment(new Date()).format('YYYY-MM-DD')}` }}
                          {...getFieldProps('start_date')}
                          error={Boolean(touched.start_date && errors.start_date)}
                          helperText={touched.start_date && errors.start_date}
                        /> */}
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: "#5a6b7d",
                            mb: 1,
                            textAlign: "left",
                          }}
                        >
                          Select time slot
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TimeWrapper>
                          {availableTimes?.length ? (
                            <Field name="start_time">
                              {({ field }) =>
                                availableTimes.map((option) => (
                                  <div
                                    key={option.value}
                                    className={`${
                                      field.value === option.value
                                        ? "timeItemStyle timeSelected"
                                        : "timeItemStyle"
                                    }`}
                                    onClick={() =>
                                      setFieldValue("start_time", option.value)
                                    }
                                  >
                                    <input
                                      type="radio"
                                      id={option.value}
                                      {...field}
                                      value={option.value}
                                      checked={field.value === option.value}
                                    />
                                    <label htmlFor={option.value}>
                                      {option.label}
                                    </label>
                                  </div>
                                ))
                              }
                            </Field>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                color: "#a3a4a4",
                                padding: "40px 0",
                              }}
                            >
                              <AccessTime style={{ fontSize: "30px" }} />
                              <p>Please select a date first.</p>
                            </div>
                          )}
                          <ErrorMessage
                            name="start_time"
                            component="div"
                            className="error"
                          />
                        </TimeWrapper>
                        {/* <TextField
                          size="small"
                          fullWidth
                          type="time"
                          {...getFieldProps('start_time')}
                          error={Boolean(touched.start_time && errors.start_time)}
                          helperText={touched.start_time && errors.start_time}
                        /> */}
                      </Grid>
                    </Grid>
                    <Box>
                      <Paper
                        elevation={0}
                        sx={{
                          padding: "16px 18px",
                          marginTop: "16px",
                          borderRadius: CARD_RADIUS,
                          border: "1px solid #e1e8ef",
                          bgcolor: "#fafbfd",
                          textAlign: "left",
                          "& p": { margin: 0, fontSize: "0.875rem", color: "#5a6b7d", lineHeight: 1.55 },
                        }}
                      >
                        <Typography component="p" sx={{ mb: 1.25 }}>
                          Appointment reservation is for the hourly time window
                          selected (example: 12pm slot ~ 12pm–1pm arrival). This
                          is a request; you will receive an auto confirmation.
                          Charges are processed on the day of service. We will
                          reach out within 24 hours if any changes are needed.
                        </Typography>
                        <Typography component="p" sx={{ fontWeight: 600, color: "#1e3a5f" }}>
                          Same day bookings — please call or email customer
                          service for availability.
                        </Typography>
                      </Paper>
                    </Box>
                    <Divider sx={SECTION_DIVIDER_SX} />
                    <StepHeader
                      step={5}
                      title="Service Address"
                      subtitle="Where should we clean?"
                    />
                    <Grid
                      container
                      rowSpacing={2}
                      columnSpacing={3}
                      sx={{
                        mt: 0.5,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                        },
                      }}
                    >
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          First Name<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: "First name" }}
                          {...getFieldProps("first_name")}
                          error={Boolean(
                            touched.first_name && errors.first_name
                          )}
                          helperText={touched.first_name && errors.first_name}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Last Name<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: "Last name" }}
                          {...getFieldProps("last_name")}
                          error={Boolean(touched.last_name && errors.last_name)}
                          helperText={touched.last_name && errors.last_name}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Street Address<span style={{ color: "red" }}>*</span>
                        </h3>
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyD7Y6D1Vbeyy6_-2nYEpNdqUaLoXaf7EXs"
                          fetchDetails={true}
                          selectProps={{
                            value: streetValue,
                            onChange: (address) => {
                              addressGeocodeRequest.current += 1;
                              setStreetValue(address);
                              setFieldValue("latitude", "");
                              setFieldValue("longitude", "");
                            },
                          }}
                        />
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "0.75rem",
                            lineHeight: 1.66,
                            letterSpacing: "0.03333em",
                            textAlign: "left",
                            marginTop: "4px",
                            marginRight: "14px",
                            marginBottom: "0",
                            marginLeft: "14px",
                            color: "#FF3D57",
                          }}
                        >
                          {Boolean(
                            touched.street_address && errors.street_address
                          )
                            ? touched.street_address && errors.street_address
                            : null}
                        </span>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Apt # (optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{
                            placeholder: "Apartment, Studio or Floor",
                          }}
                          {...getFieldProps("apt_suite")}
                          error={Boolean(touched.apt_suite && errors.apt_suite)}
                          helperText={touched.apt_suite && errors.apt_suite}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          City<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("city")}
                          error={Boolean(touched.city && errors.city)}
                          helperText={touched.city && errors.city}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          State<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("state")}
                          error={Boolean(touched.state && errors.state)}
                          helperText={touched.state && errors.state}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Zip Code<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="number"
                          {...getFieldProps("zip_code")}
                          error={Boolean(touched.zip_code && errors.zip_code)}
                          helperText={touched.zip_code && errors.zip_code}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Phone Number<span style={{ color: "red" }}>*</span>
                        </h3>
                        {/* <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("")}
                          error={Boolean(touched.phone && errors.phone)}
                          helperText={touched.phone && errors.phone}
                        /> */}
                        {/* <PhoneInput
                          specialLabel=''
                          country={'us'}
                          enableSearch
                          value={values?.phone}
                          disabled={customerDetail?.phone_no}
                          onChange={phone => setFieldValue('phone', '+' + phone)}
                          inputStyle={{
                            width: '100%',
                            height: '32px',
                          }}
                        /> */}
                        <MuiTelInput
                          focusOnSelectCountry
                          value={values?.phone}
                          onChange={(phone) => setFieldValue("phone", phone)}
                          disabled={customerDetail?.phone_no}
                          size="small"
                          variant="outlined"
                          fullWidth={true}
                        />
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "0.75rem",
                            lineHeight: 1.66,
                            letterSpacing: "0.03333em",
                            textAlign: "left",
                            marginTop: "4px",
                            marginRight: "14px",
                            marginBottom: "0",
                            marginLeft: "14px",
                            color: "#FF3D57",
                          }}
                        >
                          {Boolean(touched.phone && errors.phone)
                            ? touched.phone && errors.phone
                            : null}
                        </span>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Email<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="email"
                          disabled={customerDetail?.email}
                          {...getFieldProps("email")}
                          error={Boolean(touched.email && errors.email)}
                          helperText={touched.email && errors.email}
                        />
                      </Grid>
                      {bookingData?.name?.toLowerCase().includes("carpet") && (
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <h3
                            style={{ marginTop: "unset", marginBottom: "5px" }}
                          >
                            Do you have parking spot?
                          </h3>
                          <TextField
                            fullWidth
                            type="text"
                            select
                            size="small"
                            value={values.do_parking_spot}
                            name="do_parking_spot"
                            onChange={(e) =>
                              setFieldValue("do_parking_spot", e.target.value)
                            }
                            error={Boolean(
                              touched.do_parking_spot && errors.do_parking_spot
                            )}
                            helperText={
                              touched.do_parking_spot && errors.do_parking_spot
                            }
                          >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                          </TextField>
                        </Grid>
                      )}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          How did you hear about us? (Optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          select
                          {...getFieldProps("hear_about_us")}
                          error={Boolean(
                            touched.hear_about_us && errors.hear_about_us
                          )}
                          helperText={
                            touched.hear_about_us && errors.hear_about_us
                          }
                        >
                          {findUsList?.length ? findUsList?.map((item) => {
                            return (
                              <MenuItem value={item?.title} key={item?.id}>
                                {item?.title}
                              </MenuItem>
                            );
                          }) : (
                            <MenuItem disabled>No options available</MenuItem>
                          )}
                        </TextField>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Promo Code (Optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          sx={{
                            ".MuiInputBase-root": {
                              paddingRight: 0,
                            },
                          }}
                          type="text"
                          {...getFieldProps("promo_code")}
                          error={Boolean(
                            touched.promo_code && errors.promo_code
                          )}
                          helperText={touched.promo_code && errors.promo_code}
                          InputProps={{
                            endAdornment: (
                              <Button
                                variant="contained"
                                onClick={handleValidatePromo}
                              >
                                Apply
                              </Button>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Gift Card Code (Optional)
                        </h3>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => setGiftCardCodeModal(true)}
                        >
                          Validate Gift Card Code
                        </Button>
                      </Grid>
                    </Grid>
                    <Divider sx={SECTION_DIVIDER_SX} />
                    <Typography variant="h6" className="subHeadings">
                      How Will We Get In?
                    </Typography>
                    <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        {/* <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: 'How Will We Get In?' }}
                          {...getFieldProps('how_to_enter_on_premise')}
                          error={Boolean(
                            touched.how_to_enter_on_premise && errors.how_to_enter_on_premise
                          )}
                          helperText={
                            touched.how_to_enter_on_premise && errors.how_to_enter_on_premise
                          }
                        /> */}
                        <TextField
                          fullWidth
                          type="text"
                          select
                          {...getFieldProps("how_to_enter_on_premise")}
                          error={Boolean(
                            touched.how_to_enter_on_premise &&
                              errors.how_to_enter_on_premise
                          )}
                          helperText={
                            touched.how_to_enter_on_premise &&
                            errors.how_to_enter_on_premise
                          }
                        >
                          <MenuItem value={"ill be home"}>
                            I'll be at home
                          </MenuItem>
                          <MenuItem value={"key with doorman"}>
                            The key is with doorman
                          </MenuItem>
                          <MenuItem value={"lockbox on premises"}>
                            Lockbox on premises
                          </MenuItem>
                          <MenuItem value={`I'll call/email to organize`}>
                            Call to organize
                          </MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                    <Divider sx={SECTION_DIVIDER_SX} />
                    <Typography
                      variant="h6"
                      className="subHeadings"
                      style={{ paddingBottom: "0px" }}
                    >
                      Are there any addtional details we need to know?
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ paddingBottom: "1rem" }}
                    >
                      You can email us at support@bookcleany.com with photos,
                      floorplan or anyother relevent informations
                    </Typography>
                    <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Additional Information
                          <span style={{ color: "red" }}></span>
                        </h3>
                        <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{
                            placeholder: "Additional information...",
                          }}
                          {...getFieldProps("additional_info")}
                          error={Boolean(
                            touched.additional_info && errors.additional_info
                          )}
                          helperText={
                            touched.additional_info && errors.additional_info
                          }
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={SECTION_DIVIDER_SX} />

                    {/* <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        <h3 style={{ marginTop: '1rem', marginBottom: '5px' }}>
                          Customer Notes<span style={{ color: 'red' }}></span>
                        </h3>
                        <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: 'Customer notes...' }}
                          {...getFieldProps('customer_notes')}
                          error={Boolean(touched.customer_notes && errors.customer_notes)}
                          helperText={touched.customer_notes && errors.customer_notes}
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: '2rem' }} /> */}
                    <StepHeader
                      step={6}
                      title="Payment Details"
                      subtitle="Charged on the day of service"
                    />

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.5,
                        mb: 2,
                        mt: 1,
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          py: 1.25,
                          px: 2,
                          textAlign: "center",
                          borderRadius: "999px",
                          fontWeight: 600,
                          cursor: "pointer",
                          backgroundColor:
                            selectedMethod === "stripe"
                              ? "rgba(52, 152, 219, 0.14)"
                              : "#fff",
                          border:
                            selectedMethod === "stripe"
                              ? `2px solid ${PRIMARY_BLUE}`
                              : "1px solid #d8dee6",
                          color: "#1e3a5f",
                        }}
                        onClick={() => setSelectedMethod("stripe")}
                      >
                        Stripe
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                          py: 1.25,
                          px: 2,
                          textAlign: "center",
                          borderRadius: "999px",
                          fontWeight: 600,
                          cursor: "pointer",
                          backgroundColor:
                            selectedMethod === "zelle"
                              ? "rgba(52, 152, 219, 0.14)"
                              : "#fff",
                          border:
                            selectedMethod === "zelle"
                              ? `2px solid ${PRIMARY_BLUE}`
                              : "1px solid #d8dee6",
                          color: "#1e3a5f",
                        }}
                        onClick={() => setSelectedMethod("zelle")}
                      >
                        Zelle
                      </Box>
                    </Box>
                    {selectedMethod === "stripe" ? (
                      <>
                        {(!userCardDetails?.length > 0 && (
                          <Elements stripe={stripePromise}>
                            <ElementsConsumer>
                              {({ stripe, elements }) => (
                                <>
                                  <Box
                                    sx={{
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <TextField
                                      size="medium"
                                      fullWidth
                                      type="text"
                                      inputProps={{
                                        placeholder: "Name (Required)",
                                      }}
                                      value={values.cardHolderName}
                                      onChange={(e) =>
                                        setFieldValue(
                                          "cardHolderName",
                                          e.target.value
                                        )
                                      }
                                      error={Boolean(
                                        touched.cardHolderName &&
                                          errors.cardHolderName
                                      )}
                                      helperText={
                                        touched.cardHolderName &&
                                        errors.cardHolderName
                                      }
                                    />
                                  </Box>
                                  <Box
                                    sx={{
                                      borderRadius: "4px",
                                      border: Boolean(errors.card_token)
                                        ? "1px solid #e5424d"
                                        : "1px solid rgba(0, 0, 0, 0.23);",
                                    }}
                                  >
                                    <CardElement
                                      options={CARD_ELEMENT_OPTIONS}
                                      onReady={(element) => {
                                        setElements(elements);
                                      }}
                                      onChange={(event) => {
                                        setStripe(stripe);
                                      }}
                                    />
                                  </Box>
                                  {Boolean(errors.card_token) && (
                                    <Box
                                      sx={{
                                        color: "#FF3D57",
                                        fontWeight: "400",
                                        fontSize: "0.75rem",
                                        letterSpacing: "0.03333em",
                                        marginTop: "4px",
                                        marginBottom: "0",
                                        marginLeft: "14px",
                                      }}
                                    >
                                      {errors.card_token}
                                    </Box>
                                  )}
                                  {/* <Box textAlign={'center'} paddingTop="1rem">
                                <Button
                                  variant="contained"
                                  color="inherit"
                                  onClick={() => handleCardSubmit(stripe, elements)}
                                  disabled={values?.card_token === '' ? false : true}
                                >
                                  Apply Card
                                </Button>
                              </Box> */}
                                  <Typography
                                    fontSize={"14px"}
                                    color={"#8a94a9"}
                                    marginTop={"20px"}
                                  >
                                    I authorize the operator to send
                                    instructions to the financial institution
                                    that issued my card to take payments from my
                                    card account in accordance with the terms of
                                    my agreement with you.
                                  </Typography>
                                  <FormGroup sx={{ marginTop: "2rem" }}>
                                    <FormControlLabel
                                      control={<Checkbox defaultChecked />}
                                      label="By competing this booking, I understand that I am purchasing a onetime or reccuring service subject to Cleany's Policies and Terms Of Service and my payment method will be charged before each booking."
                                    />
                                  </FormGroup>
                                </>
                              )}
                            </ElementsConsumer>
                          </Elements>
                        )) || (
                          <Box
                            sx={{
                              display: "grid",
                              gap: "10px",
                              width: "100%",
                              "& h4": {
                                margin: "unset",
                              },
                              "& p": {
                                margin: "unset",
                              },
                            }}
                          >
                            {userCardDetails?.map((item, index) => {
                              const isCardSelected = selectedCard === item?.id;
                              return (
                                <Box
                                  key={index}
                                  onClick={() => {
                                    setSelectedCard(item?.id);
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    padding: "14px 18px",
                                    backgroundColor: isCardSelected
                                      ? "rgba(52, 152, 219, 0.12)"
                                      : "#f9fbfd",
                                    border: `1px solid ${
                                      isCardSelected ? PRIMARY_BLUE : "#e1e8ef"
                                    }`,
                                    borderRadius: CARD_RADIUS,
                                    cursor: "pointer",
                                    mb: 1.5,
                                  }}
                                >
                                  <Box sx={{ display: "flex", pt: 0.5, flexShrink: 0 }}>
                                    <div>{creditCardIcon(item?.brand)}</div>
                                  </Box>
                                  <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        fontWeight: 600,
                                        color: "#1e3a5f",
                                        lineHeight: 1.35,
                                      }}
                                    >
                                      •••• •••• •••• {item?.last4}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#6b7b90", mt: 0.25 }}
                                    >
                                      Expires {item?.exp_month}/{item?.exp_year}{" "}
                                      — {item?.name}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: 22,
                                      height: 22,
                                      borderRadius: "50%",
                                      border: `2px solid ${
                                        isCardSelected ? PRIMARY_BLUE : "#cfd8e3"
                                      }`,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                    }}
                                  >
                                    {isCardSelected ? (
                                      <Box
                                        sx={{
                                          width: 10,
                                          height: 10,
                                          borderRadius: "50%",
                                          bgcolor: PRIMARY_BLUE,
                                        }}
                                      />
                                    ) : null}
                                  </Box>
                                </Box>
                              );
                            })}
                            {/* <Grid container rowGap={2}>
                            <Grid item xs={6}>
                              <h4>Card name</h4>
                              <p>{userCardDetails?.brand}</p>
                            </Grid>
                            <Grid item xs={6}>
                              <h4>Card no</h4>
                              <p>**** **** **** {userCardDetails?.card}</p>
                            </Grid>
                            <Grid item xs={6}>
                              <h4>Expiry month</h4>
                              <p>{userCardDetails?.exp_month}</p>
                            </Grid>
                            <Grid item xs={6}>
                              <h4>Expiry year</h4>
                              <p>{userCardDetails?.exp_year}</p>
                            </Grid>
                          </Grid> */}
                            <Box
                              component={Link}
                              to="/dashboard/payment-methods"
                              sx={{
                                mt: 1,
                                py: 2,
                                px: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 0.75,
                                borderRadius: CARD_RADIUS,
                                border: "2px dashed #cfd8e3",
                                color: PRIMARY_BLUE,
                                fontWeight: 600,
                                textDecoration: "none",
                                "&:hover": {
                                  borderColor: PRIMARY_BLUE,
                                  bgcolor: "rgba(52, 152, 219, 0.06)",
                                },
                              }}
                            >
                              <AddIcon fontSize="small" />
                              Add a new card
                            </Box>
                          </Box>
                        )}
                      </>
                    ) : (
                      <>
                        <Box
                          padding={"5px 20px"}
                          backgroundColor={"#f9f9fb"}
                          border={`1px solid #ddd`}
                          borderRadius={"5px"}
                          textAlign={"left"}
                        >
                          <p>
                            Send{" "}
                            <span>
                              $
                              {finalTotal.toFixed(2)}
                            </span>{" "}
                            via{" "}
                            <a
                              style={{ color: "#6d1fd4" }}
                              rel="noreferrer"
                              href="https://zellepay.com/"
                              target="_blank"
                            >
                              Zelle
                            </a>{" "}
                            or from your bank.
                          </p>
                          <p>
                            Here are the Zelle details you should know for the
                            transfer
                          </p>
                          <p>
                            Zelle Name: <br />
                            Zelle Email:{" "}
                            <strong>{customerDetail?.email || ""}</strong>
                            <br />
                            Zelle Phone:{" "}
                          </p>
                          <p>
                            Please{" "}
                            <strong>
                              use your Order Number (available once you place
                              order)
                            </strong>{" "}
                            as the payment reference.
                          </p>
                          <p>
                            <strong>
                              After paying, please come back here and place the
                              order below
                            </strong>{" "}
                            so we can start processing your order.
                          </p>
                        </Box>
                      </>
                    )}

                    <LoadingButton
                      type="submit"
                      size="large"
                      loading={loading}
                      disabled={loading}
                      variant="contained"
                      fullWidth
                      sx={{
                        mb: 2,
                        mt: 3,
                        py: 1.5,
                        borderRadius: "12px",
                        fontWeight: 700,
                        fontSize: "1rem",
                        textTransform: "none",
                        color: "#fff",
                        background: `linear-gradient(90deg, ${PRIMARY_BLUE} 0%, ${PRIMARY_BLUE_DEEP} 100%)`,
                        boxShadow: `0 8px 20px rgba(25, 118, 210, 0.28)`,
                        "&:hover": {
                          background: `linear-gradient(90deg, #2980b9 0%, #1565c0 100%)`,
                          boxShadow: `0 10px 24px rgba(25, 118, 210, 0.38)`,
                        },
                      }}
                    >
                      Book Now — Confirm Cleaning
                    </LoadingButton>
                  </Box>
                </Form>
              </FormikProvider>
            </Box>
            <Box
              sx={{
                background: "white",
                p: { xs: 2, sm: 3 },
                width: "100%",
                border: "1px solid #e1e8ef",
                borderRadius: CARD_RADIUS,
                boxShadow: "0 4px 24px rgba(15, 41, 77, 0.06)",
                mt: { xs: 2, md: 4 },
                mb: { xs: 2, md: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "#2c2c54",
                  mb: 2.5,
                  textAlign: "left",
                  fontSize: { xs: "1.15rem", sm: "1.35rem" },
                }}
              >
                Here&apos;s why Cleany is different
              </Typography>

              <Accordion
                disableGutters
                elevation={0}
                expanded={whyCleanyExpanded === "panel1"}
                onChange={handleWhyCleanyAccordion("panel1")}
                sx={{
                  mb: 2,
                  border: "1px solid #dce4ec",
                  borderRadius: `${CARD_RADIUS}`,
                  boxShadow: "none",
                  "&:before": { display: "none" },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: PRIMARY_BLUE }} />}
                  sx={{
                    px: 2,
                    py: 1.75,
                    "& .MuiAccordionSummary-content": { my: 0 },
                  }}
                >
                  <Typography sx={{ fontSize: "1rem", color: "#3d4f63", fontWeight: 600 }}>
                    Instant online booking with live customer support 7am-11pm
                    availability
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    px: 2,
                    pt: 0,
                    pb: 2.5,
                    borderTop: "1px solid #eef2f6",
                  }}
                >
                  <Typography sx={{ fontSize: "0.95rem", color: "#6b7b90", lineHeight: 1.65, pt: 2 }}>
                    Ordering a professional cleaning service with Cleany is simple as 1-2-3.
                    Our online booking platform makes it easy to book with our cleaning
                    packages and individual add ons. We take great pride in our customer
                    service and we are available by phone or email during the week from 7 am - 11
                    pm and similar hours on weekends for your questions and requests.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                disableGutters
                elevation={0}
                expanded={whyCleanyExpanded === "panel2"}
                onChange={handleWhyCleanyAccordion("panel2")}
                sx={{
                  mb: 2,
                  border: "1px solid #dce4ec",
                  borderRadius: `${CARD_RADIUS}`,
                  boxShadow: "none",
                  "&:before": { display: "none" },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: PRIMARY_BLUE }} />}
                  sx={{
                    px: 2,
                    py: 1.75,
                    "& .MuiAccordionSummary-content": { my: 0 },
                  }}
                >
                  <Typography sx={{ fontSize: "1rem", color: "#3d4f63", fontWeight: 600 }}>
                    We bring all the cleaning supplies
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    px: 2,
                    pt: 0,
                    pb: 2.5,
                    borderTop: "1px solid #eef2f6",
                  }}
                >
                  <Typography sx={{ fontSize: "0.95rem", color: "#6b7b90", lineHeight: 1.65, pt: 2 }}>
                    You read that right! We use and provide environmentally friendly supplies
                    (besides our EPA-registered disinfectants & heavy duty products). We DO bring a
                    vacuum, swiffer or microfiber mop & natural cleaning products to name a few.
                    We DON&apos;T bring a ladder or step stool, toilet brush or pest control
                    products. For any special requests please reach out at least 24 hours prior to
                    scheduled appointment.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                disableGutters
                elevation={0}
                expanded={whyCleanyExpanded === "panel3"}
                onChange={handleWhyCleanyAccordion("panel3")}
                sx={{
                  mb: 0,
                  border: "1px solid #dce4ec",
                  borderRadius: `${CARD_RADIUS}`,
                  boxShadow: "none",
                  "&:before": { display: "none" },
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: PRIMARY_BLUE }} />}
                  sx={{
                    px: 2,
                    py: 1.75,
                    "& .MuiAccordionSummary-content": { my: 0 },
                  }}
                >
                  <Typography sx={{ fontSize: "1rem", color: "#3d4f63", fontWeight: 600 }}>
                    The Cleany Happiness Guarantee
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    px: 2,
                    pt: 0,
                    pb: 2.5,
                    borderTop: "1px solid #eef2f6",
                  }}
                >
                  <Typography sx={{ fontSize: "0.95rem", color: "#6b7b90", lineHeight: 1.65, pt: 2 }}>
                    We want you to be happy and satisfied with every cleaning service we provide.
                    That&apos;s why we have the Cleany Happiness Guarantee for every appointment!
                    If for any reason you are not satisfied with your results, We will expedite a
                    free reclean around your next availability. You can book with confidence with
                    Cleany.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Box
              sx={{
                position: { xs: "static", lg: "sticky" },
                top: { lg: "8rem" },
                maxHeight: { lg: "calc(100vh - 9rem)" },
                overflowY: { lg: "auto" },
                overflowX: "hidden",
                pr: { lg: 0.5 },
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c4cfdb",
                  borderRadius: "6px",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "white",
                  p: 2,
                  border: "1px solid #e1e8ef",
                  borderRadius: CARD_RADIUS,
                  boxShadow: "0 4px 24px rgba(15, 41, 77, 0.06)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "#1e3a5f",
                    pb: 1,
                  }}
                >
                  Booking Summary
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#6b7b90", pb: 1.5 }}
                >
                  {values?.frequency === "once" && "One Time Cleaning Plan"}
                  {values?.frequency === "weekly" && "Weekly Cleaning Plan"}
                  {values?.frequency === "biweekly" && "Biweekly Cleaning Plan"}
                  {values?.frequency === "monthly" && "Monthly Cleaning Plan"}
                  {!values?.frequency && "Select frequency"}
                </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* {frequency !== 'once' && (
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    6 Months
                  </Typography>
                )} */}
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Date & Time:{" "}
                  </Typography>
                  <Typography variant="body1">
                    {values.start_date
                      ? moment(values.start_date).format("MMMM DD, YYYY")
                      : ""}{" "}
                    -{" "}
                    {availableTimes.find((z) => z.value === values?.start_time)
                      ?.label || ""}
                  </Typography>
                </div>
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <BookingSelectionBreakdown
                  selectedItems={selectedBookingItems}
                  selectedExtras={selectedBookingExtras}
                  availableExtras={bookingData?.extras || []}
                />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent="space-between"
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Required time
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    {Number(totalHours.toFixed(2))} hrs
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Per cleaning
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {itemSubtotal.toFixed(2)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Discounts
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{ fontSize: "1rem" }}
                    sx={{ color: "#2e7d32", fontWeight: 600 }}
                  >
                    $
                    {itemDiscountTotal.toFixed(2)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Extras
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {extrasTotal.toFixed(2)}
                  </Typography>
                </Box>
                {/* <Box
                  display={'flex'}
                  alignItems="center"
                  justifyContent={'space-between'}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    Tax Rate
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    {bookingData?.tax?.[0]?.tax_rate}%
                  </Typography>
                </Box> */}
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Estimated Tax
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    ${estimatedTax ? estimatedTax?.toFixed(2) : 0}
                  </Typography>
                </Box>
                {promoDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Promo Code Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${promoDiscount ? promoDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                {giftCardDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Gift Card Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${giftCardDiscount ? giftCardDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "#1e3a5f" }}
                  >
                    Today&apos;s Total
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 800, color: PRIMARY_BLUE, fontSize: "1.35rem" }}
                  >
                    $
                    {finalTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={giftCardCodeModal}
        onClose={() => setGiftCardCodeModal(false)}
        maxWidth={"sm"}
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        aria-labelledby="package-item"
        aria-describedby="package-item-description"
      >
        <DialogTitle id="package-item" style={{ fontSize: "1.5rem" }}>
          Validate Gift Card Code
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                type="text"
                inputProps={{ placeholder: "Gift Card Code" }}
                value={giftCardCode}
                onChange={(e) => setGiftCardCode(e.target.value)}
              />
            </Grid>
          </Grid>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent={"end"}
            sx={{ mb: 2, mt: 3 }}
          >
            <Button
              onClick={() => {
                setGiftCardCodeModal(false);
              }}
              variant="outlined"
              color="primary"
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={handleValidateGiftCard}
              color="primary"
              loading={loading}
              variant="contained"
            >
              Apply
            </LoadingButton>
          </Box>
        </DialogContent>
      </Dialog>
      <Toaster position="top-right" />
    </MainBox>
  );
}

export default memo(CustomerBooking);
